import { Controller } from "@hotwired/stimulus"
import throttle from "../../utils/throttle"
export default class extends Controller {
    connect() {

    }
    toggleMenu() {
        if(this.element.getAttribute("data-menuopen")) {
            this.element.removeAttribute("data-menuopen")
        } else {
            this.element.setAttribute("data-menuopen", "true")
        }
    }
}
